export enum ModesType {
  New = 'new',
  Edit = 'edit',
  Preview = 'preview',
}
